export default "__VITE_ASSET__e1747d0f__"